import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Send } from 'lucide-react';
import { Button } from '../components/Button';
import { Card, CardContent } from '../components/Card';
import { Input } from '../components/Input';
import { RadioGroup, Radio } from '../components/RadioGroup';
import { Select } from '../components/Select';
export function ReservationRequest() {
  const [space, setSpace] = useState('koffiebar');
  const [formula, setFormula] = useState('');
  const [timeSlot, setTimeSlot] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Mock submission
    alert('Bedankt voor je aanvraag! We nemen binnenkort contact op.');
  };
  const formulaOptions = [{
    value: 'vergadering',
    label: 'Vergadering met koffie'
  }, {
    value: 'workshop',
    label: 'Workshop op maat'
  }, {
    value: 'feest',
    label: 'Feest of receptie'
  }, {
    value: 'coworking',
    label: 'Coworking dag'
  }, {
    value: 'anders',
    label: 'Eigen vraag / Andere'
  }];
  const timeOptions = [{
    value: 'voormiddag',
    label: 'Voormiddag (9:00-13:00)'
  }, {
    value: 'namiddag',
    label: 'Namiddag (13:00-17:00)'
  }, {
    value: 'avond',
    label: 'Avond (17:00-21:00)'
  }, {
    value: 'heledag',
    label: 'Hele dag (9:00-21:00)'
  }];
  return <div className="container mx-auto px-4 py-10" data-id="element-1185">
      <div className="max-w-3xl mx-auto" data-id="element-1186">
        <div className="mb-8" data-id="element-1187">
          <Link to="/locatie-huren" className="text-gray-600 hover:underline inline-flex items-center group" data-id="element-1188">
            <ArrowLeft size={16} className="mr-1 group-hover:-translate-x-1 transition-transform duration-200" data-id="element-1189" />
            Terug naar Locatie huren
          </Link>
        </div>

        <div className="text-center mb-10" data-id="element-1190">
          <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1191">
            Reservatie aanvragen
          </h1>
          <p className="text-gray-600" data-id="element-1192">
            Vul onderstaand formulier in en we nemen zo snel mogelijk contact
            met je op om je aanvraag te bespreken.
          </p>
        </div>

        <Card variant="outlined" data-id="element-1193">
          <CardContent className="p-6 md:p-8" data-id="element-1194">
            <form onSubmit={handleSubmit} className="space-y-8" data-id="element-1195">
              {/* Space Selection */}
              <div data-id="element-1196">
                <h3 className="text-lg font-bold mb-4 border-b border-gray-200 pb-2" data-id="element-1197">
                  1. Welke ruimte wil je huren?
                </h3>
                <RadioGroup value={space} onChange={setSpace} orientation="horizontal" spacing="loose" data-id="element-1198">
                  <Radio value="koffiebar" data-id="element-1199">Koffiebar (max 30 pers.)</Radio>
                  <Radio value="atelier" data-id="element-1200">Atelier (max 20 pers.)</Radio>
                </RadioGroup>
              </div>

              {/* Formula & Details */}
              <div data-id="element-1201">
                <h3 className="text-lg font-bold mb-4 border-b border-gray-200 pb-2" data-id="element-1202">
                  2. Details van je aanvraag
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1203">
                  <div className="md:col-span-2" data-id="element-1204">
                    <Select label="Gewenste formule" placeholder="Kies een formule" options={formulaOptions} value={formula} onChange={val => setFormula(val as string)} required data-id="element-1205" />
                  </div>

                  {formula === 'anders' && <div className="md:col-span-2" data-id="element-1206">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1207">
                        Beschrijf je idee
                      </label>
                      <textarea className="w-full min-h-[120px] p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400 focus:border-transparent text-sm" placeholder="Vertel ons wat je in gedachten hebt..." data-id="element-1208"></textarea>
                      <p className="text-xs text-gray-500 mt-1" data-id="element-1209">
                        Geef een korte omschrijving van wat je wil organiseren.
                      </p>
                    </div>}

                  <div data-id="element-1210">
                    <Input label="Gewenste datum" type="date" required data-id="element-1211" />
                  </div>

                  <div data-id="element-1212">
                    <Select label="Tijdstip" placeholder="Kies een tijdstip" options={timeOptions} value={timeSlot} onChange={val => setTimeSlot(val as string)} required data-id="element-1213" />
                  </div>

                  <div className="md:col-span-2" data-id="element-1214">
                    <Input label="Verwacht aantal personen" type="number" placeholder="Bijv. 12" min={1} max={space === 'koffiebar' ? 30 : 20} required data-id="element-1215" />
                  </div>
                </div>
              </div>

              {/* Contact Info */}
              <div data-id="element-1216">
                <h3 className="text-lg font-bold mb-4 border-b border-gray-200 pb-2" data-id="element-1217">
                  3. Jouw gegevens
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1218">
                  <div className="md:col-span-2" data-id="element-1219">
                    <Input label="Naam / Organisatie" placeholder="Jouw naam of bedrijfsnaam" required data-id="element-1220" />
                  </div>

                  <div data-id="element-1221">
                    <Input label="E-mailadres" type="email" placeholder="naam@voorbeeld.be" required data-id="element-1222" />
                  </div>

                  <div data-id="element-1223">
                    <Input label="Telefoonnummer" type="tel" placeholder="04xx xx xx xx" required data-id="element-1224" />
                  </div>

                  <div className="md:col-span-2" data-id="element-1225">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1226">
                      Bericht / Extra details
                    </label>
                    <textarea className="w-full min-h-[120px] p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400 focus:border-transparent text-sm" placeholder="Heb je specifieke wensen voor catering, opstelling of materiaal? Laat het ons weten." data-id="element-1227"></textarea>
                  </div>
                </div>
              </div>

              {/* Submit */}
              <div className="pt-4 text-center" data-id="element-1228">
                <Button type="submit" variant="primary" size="large" rightIcon={<Send size={18} data-id="element-1230" />} className="w-full md:w-auto min-w-[200px]" data-id="element-1229">
                  Aanvraag versturen
                </Button>
                <p className="text-xs text-gray-500 mt-4" data-id="element-1231">
                  We nemen binnen 2 werkdagen contact met je op om de
                  beschikbaarheid te bevestigen.
                </p>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>;
}